import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Wrapper, Label } from '../SharedStyles.element'
import { FileInputWrapper, HiddenFileInput, StyledFileLabel, FileName } from './FileField.elements'

function FileField({ id, label, disabled, onChange, accept, ...rest }) {
  const [fileName, setFileName] = useState('')

  const handleFileChange = (event) => {
    const file = event.target.files?.[0]
    if (file) {
      setFileName(file.name)
    } else {
      setFileName('')
    }
    if (onChange) onChange(event)
  }

  return (
    <Wrapper label={label}>
      {label && <Label disabled={disabled}>{label}</Label>}
      <FileInputWrapper>
        <StyledFileLabel htmlFor={id} disabled={disabled}>
          {fileName || 'Choose a file'}
        </StyledFileLabel>
        <HiddenFileInput
          id={id}
          type="file"
          accept={accept}
          disabled={disabled}
          onChange={handleFileChange}
          {...rest}
        />
        {fileName && <FileName>{fileName}</FileName>}
      </FileInputWrapper>
    </Wrapper>
  )
}

FileField.defaultProps = {
  id: '',
  label: '',
  disabled: false,
  accept: '',
  onChange: () => {},
}

FileField.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  accept: PropTypes.string,
  onChange: PropTypes.func,
}

export default FileField
